import React, { useState } from 'react';
import { FiServer, FiDatabase, FiUser, FiLock, FiCheckCircle, FiXCircle } from 'react-icons/fi';
import './App.css';

function App() {
  const [formData, setFormData] = useState({
    host: '',
    user: '',
    password: '',
    database: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState(null);
  const [connectionDetails, setConnectionDetails] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    // Reset connection status when form changes
    if (connectionStatus) {
      setConnectionStatus(null);
      setErrorMessage('');
    }
  };
  const testConnection = async () => {
  setIsLoading(true);
  setConnectionStatus(null);
  setErrorMessage('');
  setConnectionDetails(null);

  try {
    const response = await fetch('http://localhost:3001/api/test-connection', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        host: formData.host,
        user: formData.user,
        password: formData.password,
        database: formData.database
      })
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Connection failed');
    }

    setConnectionStatus('success');
    setConnectionDetails({
      ...data.connection,
      host: formData.host,
      database: formData.database
    });
  } catch (error) {
    setConnectionStatus('error');
    setErrorMessage(error.message || 'Failed to connect to the database');
    console.error('Connection error:', error);
  } finally {
    setIsLoading(false);
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    await testConnection();
  };

  return (
    <div className="app">
      <div className="form-container">
        <div className="form-header">
          <h2>MySQL Database Connection</h2>
          <p>Enter your database credentials to test the connection</p>
        </div>

        <form onSubmit={handleSubmit} className="form">
          <div className="form-group">
            <label htmlFor="host">Server Address</label>
            <div className="input-wrapper">
              <FiServer className="input-icon" />
              <input
                type="text"
                id="host"
                name="host"
                value={formData.host}
                onChange={handleChange}
                placeholder="e.g., localhost:3306"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="user">Username</label>
            <div className="input-wrapper">
              <FiUser className="input-icon" />
              <input
                type="text"
                id="user"
                name="user"
                value={formData.user}
                onChange={handleChange}
                placeholder="Enter database username"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <FiLock className="input-icon" />
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter database password"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="database">Database Name</label>
            <div className="input-wrapper">
              <FiDatabase className="input-icon" />
              <input
                type="text"
                id="database"
                name="database"
                value={formData.database}
                onChange={handleChange}
                placeholder="Enter database name"
                required
              />
            </div>
          </div>

          <div className="form-footer">
            <div className="connection-status">
              {connectionStatus === 'success' && connectionDetails && (
                <div className="status-message success">
                  <FiCheckCircle className="status-icon" />
                  <div className="connection-details">
                    <h4>✅ Connection Successful!</h4>
                    <div className="connection-info">
                      <p><strong>Server:</strong> {connectionDetails.connectionConfig?.host || connectionDetails.host}:{connectionDetails.connectionConfig?.port || '3306'}</p>
                      <p><strong>Database:</strong> {connectionDetails.current_database || connectionDetails.database}</p>
                      <p><strong>User:</strong> {connectionDetails.current_user || formData.user}</p>
                      {connectionDetails.version && <p><strong>MySQL Version:</strong> {connectionDetails.version}</p>}
                      {connectionDetails.serverUptime && <p><strong>Server Uptime:</strong> {Math.floor(connectionDetails.serverUptime / 3600)} hours</p>}
                      {connectionDetails.tableCount !== undefined && <p><strong>Tables in Database:</strong> {connectionDetails.tableCount}</p>}
                    </div>
                  </div>
                </div>
              )}
              {connectionStatus === 'error' && (
                <div className="status-message error">
                  <FiXCircle className="status-icon" />
                  {errorMessage}
                </div>
              )}
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="spinner"></span>
              ) : (
                'Test Connection'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default App;